import React from 'react';
import { Button, Modal } from 'antd-mobile';
import { CloseCircleFill } from 'antd-mobile-icons';
import PropTypes from 'prop-types';

const FailModal = ({
  isVisible,
  setIsVisible,
  message,
  title = '綁定失敗',
}) => {
  const showModal = () => {
    setIsVisible(true);
  };

  const hideModal = () => {
    setIsVisible(false);
  };

  return (
    <>
      <Button block onClick={showModal} className="cancel-button">
        綁定失敗Modal
      </Button>
      <Modal
        visible={isVisible}
        onMaskClick={hideModal}
        content={
          <div className="fail-modal-content">
            <CloseCircleFill style={{ fontSize: 64, color: '#FF433C' }} />
            <div className="subheading font-bold">{title}</div>
            <div className="text-body font-normal fail-modal-text">
              {message}
            </div>
            <Button block onClick={hideModal} className="secondary-button">
              我知道了
            </Button>
          </div>
        }
      />
    </>
  );
};

FailModal.propTypes = {
  isVisible: PropTypes.bool,
  setIsVisible: PropTypes.func,
  message: PropTypes.string,
};

export default FailModal;
